<template>
  <div class="w-full">
    <cardTitle title="人员区域统计"  cardType='shimen'/>
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <span class="statistic-title">施工区今日总入厂</span>
        <span class="statistic-count" @click="searchPersonStatistic('all')"
          >{{ areaPersonTotal }}人</span
        >
      </div>
      <div class="flex items-center">
        <span class="statistic-title">实时在厂</span>
        <span class="statistic-count" @click="searchPersonStatistic('present')"
          >{{ presentPersonTotal }}人</span
        >
      </div>
    </div>
    <div class="!w-full !h-[calc(100%-98px)]">
      <v-chart
        :options="areaPersonStatistics"
        class="!w-full !h-full"
        :autoresize="true"
        ref="personStatistic"
      ></v-chart>
    </div>
    <PersonStatisitics
      v-if="personStatisiticVisible"
      :type="personSearchStatus === 'all' ? 0 : 1"
      :personType="personSearchType"
      @close="closePersonStatisitic"
    ></PersonStatisitics>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import CockpitService from '../../service/index'
import PersonStatisitics from '../PersonStatisitics.vue'

export default {
  name: '',
  props: [],
  components: { CardTitle, PersonStatisitics },

  data() {
    return {
      personStatisiticVisible: false,
      initInterval: null,
      personSearchType: '',
      personSearchStatus: 'all',
      personDialogVisible: false,
      areaPersonTotal: 0,
      presentPersonTotal: 0,
      areaPersonStatistics: {
        grid: {
          top: '12%',
          left: '8%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(40, 48, 48, 0.3)',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 10,
          textStyle: {
            color: '#fff',
          },
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          axisLabel: {
            show: true,
            interval: (i, v) => { return true }, // 避免最后一项文字加深
            margin: 15,
            color: '#fff90',
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'rgba(0, 0, 0, .5)',
            },
          },
          data: [],
        },
        yAxis: {
          name: '（人）',
          nameLocation: 'start',
          nameGap: 10,
          nameTextStyle: {
            color: '#fff9',
            padding: [0, 0, 0, -30],
          },
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12,
            formatter: (value, index) => {
              return index % 2 === 0 ? value : ''
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D9D9D919',
            },
          },
        },
        series: [
          {
            // name: '',
            type: 'bar',
            // stack: '总量',
            barWidth: 20,
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: {
                    // 数值样式
                    color: '#fff',
                    fontSize: 12,
                  },
                },
                // 这里是颜色
                color(params) {
                  const colorList = ['#528DFF', '#AC85FF', '#75C7FF', '#C2B688', '#A6715A']
                  return colorList[params.dataIndex]
                },
              },
            },
            // data: [10, 20, 35, 12, 23],
            data: [0, 0, 0, 0, 0],
          },
        ],
      },
    }
  },
  methods: {
    closePersonStatisitic() {
      this.personStatisiticVisible = false
      this.personSearchType = ''
    },
    searchPersonStatistic(type) {
      this.personSearchStatus = type
      this.personSearchType = ''
      this.personStatisiticVisible = true
      this.getParticipateUnitTotal(type)
    }, // 获取参建单位人员统计总数
    async getParticipateUnitTotal(type) {
      const [err, res] = await CockpitService.getParticipateUnitTotal()
      if (res && res.code === 0 && res.data) {
        if (type === 'all') {
          this.areaPersonStatistics.series[0].data = _.map(res.data.list, 'count')
          this.areaPersonStatistics.xAxis.data = _.map(res.data.list, 'name')
        } else {
          this.areaPersonStatistics.series[0].data = _.map(res.data.presentList, 'count')
          this.areaPersonStatistics.xAxis.data = _.map(res.data.presentList, 'name')
        }
        this.areaPersonTotal = res.data.allCount
        this.presentPersonTotal = res.data.presentAllCount
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.initInterval)
  },
  mounted() {
    this.getParticipateUnitTotal(this.personSearchStatus)
    this.initInterval = setInterval(() => {
      this.getParticipateUnitTotal(this.personSearchStatus)
    }, 5000)
    this.$refs.personStatistic.chart.on('click', (e) => {
      console.log(e)
      this.personSearchType = e.name
      this.personStatisiticVisible = true
    })
  },
}
</script>

<style lang="scss" scoped>
.statistic-title {
  color: #fff;
  font-size: 16px;
  line-height: 25px;
}
.statistic-count {
  font-size: 24px;
  font-weight: 700;
  margin-left: 15px;
  color: #ffdc84;
  cursor: pointer;
}
</style>
